import React from 'react';

const AppMenu = () => (
  <svg
    className="icon navigation"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 41.5"
  >
    <title>Navigation</title>
    <g id="Layer_2" data-name="Layer 2">
      <g id="Layer_1-2" data-name="Layer 1">
        <path
          class="cls-1"
          d="M20.6,0H3.4A3.41,3.41,0,0,0,0,3.4V38.1a3.41,3.41,0,0,0,3.4,3.4H20.6A3.41,3.41,0,0,0,24,38.1V3.4A3.41,3.41,0,0,0,20.6,0Zm0,40H3.4a1.9,1.9,0,0,1-1.9-1.9V35.3H20.12V33.8H1.5V3.4A1.9,1.9,0,0,1,3.4,1.5H20.6a1.9,1.9,0,0,1,1.9,1.9V6.3H4.5V7.8h18V38.1A1.9,1.9,0,0,1,20.6,40Z"
        />
        <rect class="cls-1" x="8.25" y="16.3" width="8.13" height="1.5" />
        <rect class="cls-1" x="8.25" y="20.05" width="8.13" height="1.5" />
        <rect class="cls-1" x="8.25" y="23.8" width="8.13" height="1.5" />
      </g>
    </g>
  </svg>
);

export default AppMenu;
